/* Hero with Title */
import 'slick-carousel';

export function hero_with_title() {

	( ( $ ) => {

		const init = () => {

			if ( $( '.block--hero-with-title' ).length <= 0 /* && $( '.block--hero-with-title--gallery .slick-slide' ).length > 1 */ ) {
				return;
			}

			$( '.block--hero-with-title--gallery' ).each( ( i, e ) => {
				const slider = $( e );

				slider.slick( {
					arrows: false,
					autoplay: true,
					autoplaySpeed: 3000,
					dots: false,
					fade: true,
					infinite: true,
					pauseOnFocus: false,
					pauseOnHover: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					swipe: false,
					rows: 0
				} );
			} );
		}

		init();

	} )( window.jQuery );
}